import * as React from 'react'
import {CareersDescriptionRowContainer, CareersDescriptionText} from './CareersDescriptionRow.elements'

type Props = {
  text: string
}

export const CareersDescriptionRow: React.FunctionComponent<Props> = ({text}) => (
  <CareersDescriptionRowContainer>
    <CareersDescriptionText>
      {text}
    </CareersDescriptionText>
  </CareersDescriptionRowContainer>
)
